/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landskin_6_TitleInputs */

const en_landskin_6_title = /** @type {(inputs: Landskin_6_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lime Carpet`)
};

const ar_landskin_6_title = /** @type {(inputs: Landskin_6_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سجادة ليمونية`)
};

const de_landskin_6_title = /** @type {(inputs: Landskin_6_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limettenteppich`)
};

const es_landskin_6_title = /** @type {(inputs: Landskin_6_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alfombra de lima`)
};

const fr_landskin_6_title = /** @type {(inputs: Landskin_6_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prairie Citronnée`)
};

const it_landskin_6_title = /** @type {(inputs: Landskin_6_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tappeto Lime`)
};

const ja_landskin_6_title = /** @type {(inputs: Landskin_6_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ライムカーペット`)
};

const ko_landskin_6_title = /** @type {(inputs: Landskin_6_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`라임 카펫`)
};

const pt_br_landskin_6_title = /** @type {(inputs: Landskin_6_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Relva cítrica`)
};

const ru_landskin_6_title = /** @type {(inputs: Landskin_6_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Лаймовый ковёр`)
};

const th_landskin_6_title = /** @type {(inputs: Landskin_6_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`พรมสีมะนาว`)
};

const tr_landskin_6_title = /** @type {(inputs: Landskin_6_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Misket Limonu Halısı`)
};

const zh_cn_landskin_6_title = /** @type {(inputs: Landskin_6_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`青柠草毯`)
};

const zh_tw_landskin_6_title = /** @type {(inputs: Landskin_6_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`青檸草毯`)
};

/**
* | output |
* | --- |
* | "Lime Carpet" |
*
* @param {Landskin_6_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const landskin_6_title = /** @type {((inputs?: Landskin_6_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landskin_6_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landskin_6_title(inputs)
	if (locale === "ar") return ar_landskin_6_title(inputs)
	if (locale === "de") return de_landskin_6_title(inputs)
	if (locale === "es") return es_landskin_6_title(inputs)
	if (locale === "fr") return fr_landskin_6_title(inputs)
	if (locale === "it") return it_landskin_6_title(inputs)
	if (locale === "ja") return ja_landskin_6_title(inputs)
	if (locale === "ko") return ko_landskin_6_title(inputs)
	if (locale === "pt_br") return pt_br_landskin_6_title(inputs)
	if (locale === "ru") return ru_landskin_6_title(inputs)
	if (locale === "th") return th_landskin_6_title(inputs)
	if (locale === "tr") return tr_landskin_6_title(inputs)
	if (locale === "zh_cn") return zh_cn_landskin_6_title(inputs)
	return zh_tw_landskin_6_title(inputs)
});